import { Injectable } from '@angular/core';

import { Infills } from '../model/infills';
import { InfillsKindsUtilsService } from './tools/infills-kinds-utils.service';
import { StageService } from '../../../stage.service';
import { InfillsClipByFourPointService } from './tools/infills-clip-by-four-points.service';
import { RailingColorsService } from '../../services/railing-colors.service';

declare const THREE: any;

@Injectable()
export class InfillClippedByFourPointsService {
  allInfills: any[];
  constructor(
    private stageService: StageService,
    private infillsUtilsService: InfillsKindsUtilsService,
    private infillsCreateClippedByFourPointsInfillService: InfillsClipByFourPointService,
    private railingColorsService: RailingColorsService
  ) {}

  private _setFrame(
    objToCut,
    baserail,
    handrail,
    post,
    firstPoint,
    secondPoint,
    thirdPoint,
    fourthPoint,
    angleY = 0
  ) {
    const { hasFrame, rotatePanel, productType } = objToCut.userData.entity;
    const frameHeight = 0.05;
    const leftRightFrameShift =
      (post.userData.entity.postWidth || post.userData.entity.width) / 2 + frameHeight / 2;

    const firstPointToSecondPoint = secondPoint.clone().sub(firstPoint);
    const secondPointToFirstPoint = firstPoint.clone().sub(secondPoint);
    let leftFramePosition, rightFramePosition, bottomFramePosition, topFramePosition;

    /////

    const topFrameFp = thirdPoint
      .clone()
      .setY(thirdPoint.y - handrail.userData.entity.height / 2 - frameHeight / 2);

    const topFrameSp = fourthPoint
      .clone()
      .setY(fourthPoint.y - handrail.userData.entity.height / 2 - frameHeight / 2);

    const topFrameFpToTopFrameSp = topFrameSp.clone().sub(topFrameFp);
    const topFrameFpToTopFrameSpToCenterShift = topFrameFpToTopFrameSp
      .clone()
      .setLength(topFrameFpToTopFrameSp.length() / 2);
    topFramePosition = topFrameFp.clone().add(topFrameFpToTopFrameSpToCenterShift);

    // HelperLinesService.buildOneTestLineAndUpdate(topFramePosition);
    /////

    const bottomFrameFp = firstPoint
      .clone()
      .setY(firstPoint.y + baserail.userData.entity.height / 2 + frameHeight / 2);

    const bottomFrameSp = secondPoint
      .clone()
      .setY(secondPoint.y + baserail.userData.entity.height / 2 + frameHeight / 2);

    const bottomFrameFpToBottomFrameSp = bottomFrameSp.clone().sub(bottomFrameFp);
    const bottomFrameFpToBottomFrameSpToCenterShift = bottomFrameFpToBottomFrameSp
      .clone()
      .setLength(bottomFrameFpToBottomFrameSp.length() / 2);
    bottomFramePosition = bottomFrameFp.clone().add(bottomFrameFpToBottomFrameSpToCenterShift);

    // HelperLinesService.buildOneTestLineAndUpdate(bottomFramePosition, 1);

    /////

    const leftFrameFp = secondPoint
      .clone()
      .add(secondPointToFirstPoint.clone().setLength(leftRightFrameShift));

    const leftFrameSp = thirdPoint
      .clone()
      .add(secondPointToFirstPoint.clone().setLength(leftRightFrameShift));

    const leftFrameFpToLeftFrameSp = leftFrameSp.clone().sub(leftFrameFp);
    const leftFrameFpToLeftFrameSpToCenterShift = leftFrameFpToLeftFrameSp
      .clone()
      .setLength(leftFrameFpToLeftFrameSp.length() / 2);
    leftFramePosition = leftFrameFp.clone().add(leftFrameFpToLeftFrameSpToCenterShift);

    // HelperLinesService.buildOneTestLineAndUpdate(leftFramePosition, 2);

    /////

    const rightFrameFp = firstPoint
      .clone()
      .add(firstPointToSecondPoint.clone().setLength(leftRightFrameShift));

    const rightFrameSp = fourthPoint
      .clone()
      .add(firstPointToSecondPoint.clone().setLength(leftRightFrameShift));

    const rightFrameFpToRightFrameSp = rightFrameSp.clone().sub(rightFrameFp);
    const rightFrameFpToRightFrameSpToCenterShift = rightFrameFpToRightFrameSp
      .clone()
      .setLength(rightFrameFpToRightFrameSp.length() / 2);
    rightFramePosition = rightFrameFp.clone().add(rightFrameFpToRightFrameSpToCenterShift);

    // HelperLinesService.buildOneTestLineAndUpdate(rightFramePosition, 3);

    /////

    objToCut.updateMatrixWorld();

    const panel = objToCut.getObjectByName('panel');

    if (panel) {
      if (rotatePanel) panel.rotation.z = angleY;
    } else {
      console.warn(`Infill ${productType} doesn't have a panel`);
    }

    const leftFrame = objToCut.getObjectByName('frameLeft');

    if (leftFrame) {
      leftFrame.position.copy(objToCut.worldToLocal(leftFramePosition));
    }

    const rightFrame = objToCut.getObjectByName('frameRight');

    if (rightFrame) {
      rightFrame.position.copy(objToCut.worldToLocal(rightFramePosition));
    }

    const topFrame = objToCut.getObjectByName('frameTop');

    if (topFrame) {
      topFrame.position.copy(objToCut.worldToLocal(topFramePosition));
      topFrame.rotation.z = angleY;
    }

    const bottomFrame = objToCut.getObjectByName('frameBottom');

    if (bottomFrame) {
      bottomFrame.position.copy(objToCut.worldToLocal(bottomFramePosition));
      bottomFrame.rotation.z = angleY;
    }

    if (!leftFrame && !rightFrame && !topFrame && !bottomFrame && hasFrame) {
      console.warn(`Infill ${productType} supposed to be with frames, but none was found`);
    }
  }

  add(
    pos1,
    pos2,
    modelToAdd,
    baserail,
    handrail,
    post,
    allInfills: any[],
    infillType: Infills,
    angleY = 0
  ) {
    this.allInfills = allInfills;
    const frameHeight = 0.05;
    const leftRightFrameShift =
      (post.userData.entity.postWidth || post.userData.entity.width) / 2 + frameHeight / 2;

    const firstPointToSecondPoint = pos2.clone().sub(pos1);
    const secondPointToFirstPoint = pos1.clone().sub(pos2);
    
    if (modelToAdd.userData.entity.hasFrame) {
      pos1.add(firstPointToSecondPoint.setLength(leftRightFrameShift + 2));
      pos2.add(secondPointToFirstPoint.setLength(leftRightFrameShift + 2));
    }
    const {
      infill: obj,
      firstPoint,
      secondPoint,
      thirdPoint,
      fourthPoint
    } = this.infillsCreateClippedByFourPointsInfillService.clipAndPlaceInfill(
      pos1,
      pos2,
      modelToAdd,
      baserail,
      handrail,
      allInfills,
      infillType
    );

    this.railingColorsService.setExistingColor(obj, obj.userData.entity.productType);
    this.railingColorsService.syncObjColors(obj);

    if (obj.userData.entity.hasFrame) {
      secondPoint.add(firstPointToSecondPoint.setLength(leftRightFrameShift + 2));
      thirdPoint.add(firstPointToSecondPoint.setLength(leftRightFrameShift + 2));
      firstPoint.add(secondPointToFirstPoint.setLength(leftRightFrameShift + 2));
      fourthPoint.add(secondPointToFirstPoint.setLength(leftRightFrameShift + 2));
      
      pos2.add(firstPointToSecondPoint.setLength(leftRightFrameShift + 2));
      pos1.add(secondPointToFirstPoint.setLength(leftRightFrameShift + 2));

      this._setFrame(
        obj,
        baserail,
        handrail,
        post,
        firstPoint,
        secondPoint,
        thirdPoint,
        fourthPoint,
        angleY
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/infills/kinds/infills-clipped-by-four-points.service.ts